import { create } from 'zustand'
import { z } from 'zod'

const RedirectDetectionSchema = z.object({
  redirectTo: z.string().optional(),
  setRedirectTo: z.function().args(z.string().optional()).returns(z.void())
})

type RedirectDetection = z.infer<typeof RedirectDetectionSchema>

export const useRedirectDetection = create<RedirectDetection>((set) => ({
  redirectTo: undefined,
  setRedirectTo: (redirectTo?: string) => set({ redirectTo })
}))

export const checkRedirect = (): void => {
  try {
    const urlParams = new URLSearchParams(window.location.search)

    // Check for redirect URL in "to" parameter
    const redirectTo = urlParams.get('to') || undefined
    useRedirectDetection.setState({ redirectTo })
  } catch (error) {
    useRedirectDetection.setState({ redirectTo: undefined })
  }
}
